import { cn } from "@/lib/utils";

/** How full it is, at a glance: a thin bar that turns sol when seats are scarce. Nothing when there is no cap. */
export const CapacityMeter = ({ available, capacity, soldOut = false, fewLeft = false, className, compact = false, testId = "capacity-meter" }) => {
  if (capacity == null || available == null || capacity <= 0) return null;
  const taken = Math.min(Math.max(capacity - available, 0), capacity);
  const pct = Math.round((taken / capacity) * 100);
  const urgent = fewLeft && !soldOut;
  const label = soldOut ? "Fullt" : urgent ? `Få plassar att – ${available}` : `${available} av ${capacity} ledige`;
  return (
    <div className={cn("min-w-0", className)} data-testid={testId} data-pct={pct}>
      {!compact && (
        <div className="flex items-baseline justify-between gap-3 text-[12.5px] tabular">
          <span className={cn("font-medium", urgent ? "text-sol" : soldOut ? "text-muted-foreground" : "text-foreground/80")} data-testid={`${testId}-label`}>{label}</span>
          <span className="text-muted-foreground">{pct} % fylt</span>
        </div>
      )}
      <div className={cn("overflow-hidden rounded-full bg-border/70", compact ? "mt-1.5 h-1" : "mt-2 h-1.5")} role="progressbar" aria-valuemin={0} aria-valuemax={capacity} aria-valuenow={taken} aria-label={`${taken} av ${capacity} plassar tekne`}>
        <div className={cn("h-full rounded-full transition-[width] duration-700 ease-out", soldOut ? "bg-muted-foreground/60" : urgent ? "bg-sol" : "bg-foreground/70")} style={{ width: `${Math.max(pct, taken > 0 ? 3 : 0)}%` }} />
      </div>
    </div>
  );
};
